<script setup>
import { ChartBarIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { useI18n } from "vue-i18n";
import { ref } from "vue";
import DisplayContentAction from "@js/components/actions/DisplayContentAction.vue";
import LoadingSpinner from "@js/components/LoadingSpinner.vue";
import { useRoute } from "@js/utils/route";
import LineChart from "@js/components/charts/LineChart.vue";
import { toast } from "vue3-toastify";

const props = defineProps({
  keyword: {
    type: Object,
    required: true,
  },
  tenant: {
    type: String,
    required: true,
  }
});
const { t } = useI18n();
const { route } = useRoute();

const isHistoryLoading = ref(true);
const chartData = ref(null);
const loadKeywordPositionHistory = () => {
  isHistoryLoading.value = true;
  // Load keyword position history here
  axios.post(route('front.seo.tracking_position.keywords.get_tracked_history', {
    tenant: props.tenant,
    id: props.keyword.id,
  })).then((response) => {
    chartData.value = response.data;
  }).catch((error) => {
    console.error(error);
    toast.error(t('error.failedToLoadKeywordPositionHistory'));
  }).finally(() => {
    isHistoryLoading.value = false;
  });
};
</script>

<template>
  <div
    class="relative inline-flex h-full items-center p-4"
  >
    <div
      v-html="props.keyword.position"
    ></div>
    <DisplayContentAction
      :title="props.keyword.keyword + ' - ' + props.keyword.url"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          class="size-8 ml-4"
          type="secondary"
          :callback="() => {
            setIsOpen(true);
            loadKeywordPositionHistory();
          }"
          :icon="ChartBarIcon"
        />
      </template>

      <template #complexContent>
        <LoadingSpinner v-if="isHistoryLoading" />
        <div v-if="chartData">
          <LineChart
            :datasets="chartData.datasets"
            :labels="chartData.labels"
            :reverse-axis1="true"
            :title="t('title.positionHistory')"
          />
        </div>
      </template>
    </DisplayContentAction>
  </div>
</template>
